"use strict";
const options = {
    collectionsLoadMore: '.collections-load-more',
    blsLinkFilter: '.bls__link-filter',
    openFilter: '.filter-title .open-children-toggle',
    rangeSlider: '.price-range .range-slider',
    rangeSliderMin: '.range-slider-min',
    rangeSliderMax: '.range-slider-max',
    gridMode: '.grid-mode-show-type-products .grid-mode',
    viewMode: '.view-mode',
    sidebarClose: '.sidebar-close',
    collectionSidebar: '#CollectionSidebar',
    collectionFiltersForm: '#CollectionFiltersForm',
    btnFilter: '.collection-filter .btn-filter',
    section: '.section-collection-product',
    toolbarSorter: '.toolbar-sorter .select-selected',
    facetFiltersSort: '.facet-filters__sort li',
    overlay: '.bls__overlay',
    filterSortMb: '.toolbar-sorter-mb .facet-filters__label',
    dataSortMb: '.toolbar-sorter-mb__option',
    closeSortMb: '.close-select'
};

var BlsEventCollectionShopify = (function() {
    let isReplayInProgress = false; // Guard against double replay
    
    return {
        init: function() {
            this.setupEventListeners();
            this.eventLoadMore();
            this.ionRangeSlider();
            this.actionDesc();
            this.setupScrollRestore();
            
            // Initial replay for fresh page loads with hash
            this.replayPagesFromHash();
            
            // Use pageshow event for back/forward navigation
            // This handles both bfcache (swipe) and normal back button navigation
            window.addEventListener('pageshow', (event) => {
                // CRITICAL: Reset the replay flag on back/forward navigation
                // This ensures replay can run again after returning from another page
                isReplayInProgress = false;
                
                // For bfcache restoration (swipe), DOM is preserved
                // For normal navigation (back button), DOM is fresh
                // In both cases, replay hash if present
                this.replayPagesFromHash();
            });
        },

        actionDesc: function(){
            const viewMore = document.querySelector('[data-view-more]');
            if (viewMore) {
                viewMore.addEventListener('click', function(e) {
                    const target = e.currentTarget;
                    if (target.closest('.heading-description').classList.contains('show-full-desc')) {
                        target.closest('.heading-description').classList.remove('show-full-desc');
                        target.textContent = target.dataset.readMore
                    } else {
                        target.closest('.heading-description').classList.add('show-full-desc');
                        target.textContent = target.dataset.readLess
                    }
                });
            }
        },

        setupEventListeners: function() {
            document.querySelectorAll(options.btnFilter).forEach(btn => {
                btn.addEventListener("click", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    if (document.querySelector(options.collectionSidebar).classList.contains('bls__opend-popup')) {
                        target.classList.remove('actived')
                        document.querySelector(options.collectionSidebar).classList.remove('bls__opend-popup');
                        document.querySelector(options.overlay).classList.add('d-none-overlay');
                        document.documentElement.classList.remove('hside_opened');
                        if (target.closest('.collection-filter').classList.contains('dropdonw_sidebar')) {
                            if (window.innerWidth >= 1024) {
                                slideAnime({
                                    target: target.closest('#productgridcontainer').querySelector('#CollectionSidebar'),
                                    animeType: 'slideToggle'
                                });
                            }
                        }
                        target.classList.remove('actived')
                    } else {
                        target.classList.add('actived')
                        const collectionSidebar = document.querySelector(options.collectionSidebar);
                        const overlay = document.querySelector(options.overlay);
                        const collectionFilter = target.closest('.collection-filter');
                        
                        collectionSidebar.classList.add('bls__opend-popup');
                        
                        // Check if filter_canvas mode (not dropdonw_sidebar)
                        const isFilterCanvas = collectionFilter && collectionFilter.classList.contains('filter_canvas');
                        const isDropdownSidebar = collectionFilter && collectionFilter.classList.contains('dropdonw_sidebar');
                        
                        if (isFilterCanvas || (!isDropdownSidebar && window.innerWidth < 1024)) {
                            // For filter_canvas mode, always show overlay
                            document.documentElement.classList.add('hside_opened');
                            if (overlay) {
                                overlay.classList.remove('d-none-overlay');
                            }
                        } else if (isDropdownSidebar) {
                            if (window.innerWidth < 1024) {
                                document.documentElement.classList.add('hside_opened');
                                if (overlay) {
                                    overlay.classList.remove('d-none-overlay');
                                }
                            } else {
                                slideAnime({
                                    target: target.closest('#productgridcontainer').querySelector('#CollectionSidebar'),
                                    animeType: 'slideToggle'
                                });
                            }
                        }
                    }
                }, false);
            });

            document.querySelectorAll(options.openFilter).forEach(btn => {
                btn.addEventListener("click", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    slideAnime({
                        target: target.closest('.filter-item').querySelector('.filter-content'),
                        animeType: 'slideToggle'
                    });
                    if (target.classList.contains('active')) {
                        target.classList.remove('active');
                    } else {
                        target.classList.add('active')
                    }
                }, false);
            });

            document.querySelectorAll(options.sidebarClose).forEach(btn => {
                btn.addEventListener("click", event => {
                    event.preventDefault();
                    document.querySelector(options.collectionSidebar).classList.remove('bls__opend-popup');
                    if (document.querySelector(options.btnFilter)) {
                        document.querySelector(options.btnFilter).classList.remove('actived');
                    }
                    document.querySelector(options.overlay).classList.add('d-none-overlay');
                    document.documentElement.classList.remove('hside_opened');
                }, false);
            });

            document.querySelectorAll(options.viewMode).forEach(view => {
                view.addEventListener("click", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    const view_mode = target.getAttribute('data-view');
                    if (target.classList.contains('actived')) return;
                    var queryString = window.location.search;
                    queryString = this.removeParam('view', queryString);
                    if (view_mode == 'list') {
                        var searchParams = queryString.replace('?', '')+'&view=list';
                    } else {
                        var searchParams = queryString.replace('?', '')+'&view=grid';
                    }
                    const url = this.renderUrl(searchParams);
                    this.renderSectionFilter(url, searchParams);
                }, false);
            });

            document.querySelectorAll(options.gridMode).forEach(btn => {
                btn.addEventListener("click", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    const view_mode = target.getAttribute('data-grid-mode');
                    if (target.classList.contains('actived')) return;
                    if (view_mode == 1) return;
                    for (var item of document.querySelectorAll(options.gridMode)) {
                        item.classList.remove('actived');
                    }
                    const container_switch = document.querySelector('.container-products-switch');
                    target.classList.add('actived');
                    const data_view_mode = container_switch.getAttribute('data-view-mode');
                    container_switch.classList.remove('grid-columns-'+data_view_mode);
                    container_switch.setAttribute('data-view-mode',view_mode);
                    container_switch.classList.add('grid-columns-'+view_mode);
                }, false);
            });

            document.querySelectorAll(options.blsLinkFilter).forEach(btn => {
                btn.addEventListener("click", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    if (target.querySelector('.bls_tooltip')) {
                        target.querySelector('.bls_tooltip').classList.toggle('current-filter');
                    } else {
                        target.closest('li').classList.toggle('current-filter');
                    }
                    const url = target.getAttribute('href');
                    this.renderSectionFilter(url);
                }, false);
            });

            document.body.addEventListener('click', (evt) => {
                const target = evt.target;
                const btn_dropdonw_sidebar = document.querySelector('.collection-filter.dropdonw_sidebar .btn-filter');
                const collectionSidebar = document.querySelector(options.collectionSidebar);
                const isCollectionSidebarOpen = collectionSidebar && collectionSidebar.classList.contains('bls__opend-popup');
                const isOverlayClick = target.classList.contains('bls__overlay') || target.closest('.bls__overlay');
                
                if (!target.closest('.select-custom') && target != document.querySelector('.toolbar-sorter .select-custom')) {
                    if (document.querySelector('.toolbar-sorter .select-custom')) {
                        document.querySelector('.toolbar-sorter .select-custom').classList.remove('actived');
                    }
                }
                
                // If clicking on overlay and sidebar is open, close sidebar
                if (isOverlayClick && isCollectionSidebarOpen) {
                    collectionSidebar.classList.remove('bls__opend-popup');
                    const btnFilter = document.querySelector('.collection-filter .btn-filter');
                    if (btnFilter) {
                        btnFilter.classList.remove('actived');
                    }
                    document.querySelector(options.overlay).classList.add('d-none-overlay');
                    document.documentElement.classList.remove('hside_opened');
                    // If in dropdonw_sidebar mode, animate closed
                    if (btn_dropdonw_sidebar && window.innerWidth >= 1024) {
                        slideAnime({
                            target: btn_dropdonw_sidebar.closest('#productgridcontainer').querySelector('#CollectionSidebar'),
                            animeType: 'slideUp'
                        });
                    }
                    return; // Stop here, don't process other click logic
                }
                
                if (!target.closest('#CollectionSidebar') && target != document.querySelector('#CollectionSidebar') && btn_dropdonw_sidebar && target != btn_dropdonw_sidebar) {
                    if (window.innerWidth >= 1024) {
                        btn_dropdonw_sidebar.classList.remove('actived')
                        document.querySelector(options.collectionSidebar).classList.remove('bls__opend-popup');
                        document.querySelector(options.overlay).classList.add('d-none-overlay');
                        document.documentElement.classList.remove('hside_opened');
                        slideAnime({
                            target: btn_dropdonw_sidebar.closest('#productgridcontainer').querySelector('#CollectionSidebar'),
                            animeType: 'slideUp'
                        });
                    }
                }
            });

            document.querySelectorAll(options.toolbarSorter).forEach(filterSort => {
                filterSort.addEventListener("click", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    if (target.closest('.select-custom').classList.contains('actived')) {
                        target.closest('.select-custom').classList.remove('actived');
                    } else {
                        target.closest('.select-custom').classList.add('actived');
                    }
                }, false);
            });
            
            if (document.querySelector(options.filterSortMb)) {
                document.querySelector(options.filterSortMb).addEventListener('click' , event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    if (target.closest('.toolbar-sorter-mb').classList.contains('open-selected')) {
                        target.closest('.toolbar-sorter-mb').classList.remove('open-selected')
                    } else {
                        target.closest('.toolbar-sorter-mb').classList.add('open-selected')
                    }
                }, false);
            }
            
            if (document.querySelector(options.closeSortMb)) {
                document.querySelector(options.closeSortMb).addEventListener('click', event => {
                    event.preventDefault();
                    document.querySelector('.toolbar-sorter-mb').classList.remove('open-selected')
                })
            }

            document.querySelectorAll(options.facetFiltersSort).forEach(filterSort => {
                filterSort.addEventListener("click", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    const value = target.getAttribute('value');
                    var queryString = window.location.search;
                    queryString = this.removeParam('sort_by', queryString);
                    var searchParams = queryString.replace('?', '')+'&sort_by='+value;
                    const url = this.renderUrl(searchParams);
                    this.renderSectionFilter(url, searchParams);
                }, false);
            });
        },

        ionRangeSlider: function() {
            // Global function to apply ALL sliders with visible buttons
            const applyAllSliders = function() {
                const currentParams = new URLSearchParams(window.location.search);
                let hasChanges = false;
                
                // Apply price slider if button is visible
                const priceForm = document.querySelector('#CollectionFiltersForm');
                const priceApplyButton = priceForm ? priceForm.querySelector('.price-slider-apply-btn') : null;
                if (priceApplyButton && priceApplyButton.style.display !== 'none') {
                    const minPrice = priceForm.querySelector('.min-price-range');
                    const maxPrice = priceForm.querySelector('.max-price-range');
                    if (minPrice && maxPrice) {
                        const nameMin = minPrice.getAttribute('name');
                        const nameMax = maxPrice.getAttribute('name');
                        // Remove existing params
                        const keysToDelete = [];
                        for (const [key, value] of currentParams.entries()) {
                            if (key === nameMin || key === nameMax) {
                                keysToDelete.push(key);
                            }
                        }
                        keysToDelete.forEach(function(key) {
                            currentParams.delete(key);
                        });
                        // Add new params
                        if (minPrice.value) currentParams.set(nameMin, minPrice.value);
                        if (maxPrice.value) currentParams.set(nameMax, maxPrice.value);
                        hasChanges = true;
                        priceApplyButton.style.display = 'none';
                    }
                }
                
                // Apply all numeric sliders with visible buttons
                document.querySelectorAll('.filter-numeric-slider').forEach(function(sliderContainer) {
                    const applyButton = sliderContainer.querySelector('.numeric-slider-apply-btn');
                    if (applyButton && applyButton.style.display !== 'none') {
                        const minRange = sliderContainer.querySelector('.numeric-range-slider-min');
                        const maxRange = sliderContainer.querySelector('.numeric-range-slider-max');
                        const filterParam = sliderContainer.dataset.filterParam;
                        const filterValuesStr = sliderContainer.dataset.filterValues || '';
                        
                        if (minRange && maxRange && filterParam && filterValuesStr) {
                            const minVal = parseFloat(minRange.value);
                            const maxVal = parseFloat(maxRange.value);
                            
                            // Parse filter values
                            const filterValues = filterValuesStr.split('|').map(function(v) {
                                const parts = v.trim().split(':');
                                return {
                                    numeric: parseFloat(parts[0]) || 0,
                                    value: parts[0] || ''
                                };
                            }).filter(function(v) { return v.numeric > 0; });
                            
                            // Remove existing params for this filter
                            const keysToDelete = [];
                            for (const [key, value] of currentParams.entries()) {
                                if (key === filterParam) {
                                    keysToDelete.push(key);
                                }
                            }
                            keysToDelete.forEach(function(key) {
                                currentParams.delete(key);
                            });
                            
                            // Add ALL values within the selected range
                            const valuesInRange = filterValues.filter(function(v) {
                                return v.numeric >= minVal && v.numeric <= maxVal;
                            });
                            
                            if (valuesInRange.length > 0) {
                                valuesInRange.forEach(function(v) {
                                    currentParams.append(filterParam, v.value);
                                });
                                hasChanges = true;
                                applyButton.style.display = 'none';
                            }
                        }
                    }
                });
                
                // Apply all changes at once
                if (hasChanges) {
                    const searchParams = currentParams.toString();
                    const url = this.renderUrl(searchParams);
                    this.renderSectionFilter(url, searchParams);
                }
            }.bind(this);
            
            // Handle price range slider (existing) - only for price filters
            const priceForm = document.querySelector('#CollectionFiltersForm');
            if (priceForm) {
                const price_range = priceForm.querySelector('.price-range');
                const maxRange = priceForm.querySelector(options.rangeSliderMax);
                const minRange = priceForm.querySelector(options.rangeSliderMin);
                const minPrice = priceForm.querySelector('.min-price-range');
                const maxPrice = priceForm.querySelector('.max-price-range');
                const priceApplyButton = priceForm.querySelector('.price-slider-apply-btn');
                var minPriceRange = 0;
                var maxPriceRange = 0;
                
                if (price_range && maxRange && minRange && minPrice && maxPrice) {
                    // Store initial values
                    let initialMin = minPrice.value ? Number(minPrice.value) : 0;
                    let initialMax = maxPrice.value ? Number(maxPrice.value) : Number(maxRange.getAttribute('max'));
                    
                    // Function to check if price values have changed
                    const checkPriceChanges = function() {
                        const currentMin = minPrice.value ? Number(minPrice.value) : 0;
                        const currentMax = maxPrice.value ? Number(maxPrice.value) : Number(maxRange.getAttribute('max'));
                        const hasChanged = (currentMin !== initialMin || currentMax !== initialMax);
                        
                        if (priceApplyButton) {
                            if (hasChanged) {
                                priceApplyButton.style.display = 'inline-flex';
                            } else {
                                priceApplyButton.style.display = 'none';
                            }
                        }
                    };
                    
                    minRange.addEventListener("input", event => {
                        event.preventDefault();
                        const target = event.currentTarget;
                        if (Number(maxRange.value) - Number(target.value) >= 1) {
                            minPrice.value = Number(target.value);
                            minPriceRange = Number(target.value) * 100;
                        } else {
                            target.value = Number(maxRange.value) - 1;
                            minPriceRange = (Number(maxRange.value) - 1)*100;
                        }
                        const price_format = Shopify.formatMoney(minPriceRange, cartStrings.money_format);
                        const priceLabel = target.closest('.filter-item').querySelector('.price-lable .min');
                        if (priceLabel) priceLabel.innerHTML = price_format;
                        target.closest(".price-range").style.setProperty('--range-from', minRange.value / Number(target.getAttribute('max')) * 100 + '%');
                        checkPriceChanges();
                    }, false);
                    
                    maxRange.addEventListener("input", event => {
                        event.preventDefault();
                        const target = event.currentTarget;
                        if (target.value - minRange.value >= 1) {
                            maxPrice.value = target.value;
                            maxPriceRange = Number(target.value) * 100;
                        } else {
                            target.value = Number(minRange.value) + Number(1);
                            maxPriceRange = (Number(minRange.value) + Number(1)) * 100;
                        }
                        const price_format = Shopify.formatMoney(maxPriceRange, cartStrings.money_format);
                        const priceLabel = target.closest('.filter-item').querySelector('.price-lable .max');
                        if (priceLabel) priceLabel.innerHTML = price_format;
                        target.closest(".price-range").style.setProperty('--range-to', maxRange.value / Number(target.getAttribute('max')) * 100 + '%');
                        checkPriceChanges();
                    }, false);
                    
                    // Remove automatic change event - now handled by button
                    // Add click event to price apply button
                    if (priceApplyButton) {
                        priceApplyButton.addEventListener("click", function(event) {
                            event.preventDefault();
                            applyAllSliders();
                        }, false);
                    }
                }
            }
            
            // Handle numeric filter sliders (new) - activate ALL values in range at once
            document.querySelectorAll('.filter-numeric-slider').forEach(function(sliderContainer) {
                const numericRange = sliderContainer.querySelector('.numeric-range');
                const minRange = sliderContainer.querySelector('.numeric-range-slider-min');
                const maxRange = sliderContainer.querySelector('.numeric-range-slider-max');
                const minLabel = sliderContainer.querySelector('.numeric-range-label .min');
                const maxLabel = sliderContainer.querySelector('.numeric-range-label .max');
                const unitSpan = sliderContainer.querySelector('.numeric-range-label .unit');
                const applyButton = sliderContainer.querySelector('.numeric-slider-apply-btn');
                const filterParam = sliderContainer.dataset.filterParam;
                const filterValuesStr = sliderContainer.dataset.filterValues || '';
                const isMeasurement = sliderContainer.dataset.isMeasurement === 'true';
                
                // Parse filter values: format is "numeric:url_to_add:active|numeric:url_to_add:active"
                const filterValues = filterValuesStr ? filterValuesStr.split('|').map(function(v) {
                    const parts = v.trim().split(':');
                    return {
                        numeric: parseFloat(parts[0]) || 0,
                        value: parts[0] || '',  // Keep original string format
                        url: parts[1] || '',
                        active: parts[2] === '1'
                    };
                }).filter(function(v) { return v.numeric > 0; }) : [];
                
                const rangeMin = numericRange ? parseFloat(numericRange.dataset.rangeMin || 0) : 0;
                const rangeMax = numericRange ? parseFloat(numericRange.dataset.rangeMax || 100) : 100;
                
                // Helper function to format number (remove decimal if whole number)
                const formatNumber = function(num) {
                    const rounded = Math.round(num);
                    return num === rounded ? rounded : num;
                };
                
                if (minRange && maxRange && filterValues.length > 0 && filterParam) {
                    // Store initial/active values to compare later
                    let initialMin = parseFloat(minRange.value);
                    let initialMax = parseFloat(maxRange.value);
                    
                    // Check if there are active filters and set slider positions accordingly
                    const activeValues = filterValues.filter(function(v) { return v.active; });
                    if (activeValues.length > 0) {
                        const activeMin = Math.min.apply(Math, activeValues.map(function(v) { return v.numeric; }));
                        const activeMax = Math.max.apply(Math, activeValues.map(function(v) { return v.numeric; }));
                        
                        // Set slider positions to active values
                        minRange.value = activeMin;
                        maxRange.value = activeMax;
                        
                        // Store as initial values
                        initialMin = activeMin;
                        initialMax = activeMax;
                        
                        // Update labels
                        if (minLabel) minLabel.textContent = formatNumber(activeMin);
                        if (maxLabel) maxLabel.textContent = formatNumber(activeMax);
                        
                        // Update visual range bar
                        const rangeFrom = rangeMax > rangeMin ? ((activeMin - rangeMin) / (rangeMax - rangeMin)) * 100 : 0;
                        const rangeTo = rangeMax > rangeMin ? ((activeMax - rangeMin) / (rangeMax - rangeMin)) * 100 : 100;
                        if (numericRange) {
                            numericRange.style.setProperty('--range-from', rangeFrom + '%');
                            numericRange.style.setProperty('--range-to', rangeTo + '%');
                        }
                    }
                    
                    // Function to check if values have changed and show/hide apply button
                    const checkForChanges = function() {
                        const currentMin = parseFloat(minRange.value);
                        const currentMax = parseFloat(maxRange.value);
                        const hasChanged = (currentMin !== initialMin || currentMax !== initialMax);
                        
                        if (applyButton) {
                            if (hasChanged) {
                                applyButton.style.display = 'inline-flex';
                            } else {
                                applyButton.style.display = 'none';
                            }
                        }
                    };
                    
                    // Update visual feedback on slider input (no page reload)
                    minRange.addEventListener("input", function(event) {
                        const target = event.currentTarget;
                        const maxVal = parseFloat(maxRange.value);
                        const minVal = parseFloat(target.value);
                        
                        if (maxVal - minVal >= 0) {
                            if (minLabel) minLabel.textContent = formatNumber(minVal);
                            const rangeFrom = rangeMax > rangeMin ? ((minVal - rangeMin) / (rangeMax - rangeMin)) * 100 : 0;
                            if (numericRange) numericRange.style.setProperty('--range-from', rangeFrom + '%');
                        } else {
                            target.value = maxVal;
                            if (minLabel) minLabel.textContent = formatNumber(maxVal);
                        }
                        
                        // Check if values changed and show apply button
                        checkForChanges();
                    }, false);
                    
                    maxRange.addEventListener("input", function(event) {
                        const target = event.currentTarget;
                        const minVal = parseFloat(minRange.value);
                        const maxVal = parseFloat(target.value);
                        
                        if (maxVal - minVal >= 0) {
                            if (maxLabel) maxLabel.textContent = formatNumber(maxVal);
                            const rangeTo = rangeMax > rangeMin ? ((maxVal - rangeMin) / (rangeMax - rangeMin)) * 100 : 100;
                            if (numericRange) numericRange.style.setProperty('--range-to', rangeTo + '%');
                        } else {
                            target.value = minVal;
                            if (maxLabel) maxLabel.textContent = formatNumber(minVal);
                        }
                        
                        // Check if values changed and show apply button
                        checkForChanges();
                    }, false);
                    
                    // Update initial values when slider is applied (called from applyAllSliders)
                    // This is handled by the global applyAllSliders function
                    
                    // Add click event to apply button - calls global function
                    if (applyButton) {
                        applyButton.addEventListener("click", function(event) {
                            event.preventDefault();
                            // Update initial values for this slider
                            initialMin = parseFloat(minRange.value);
                            initialMax = parseFloat(maxRange.value);
                            // Apply all sliders
                            applyAllSliders();
                        }, false);
                    }
                }
            }.bind(this));
        },

        removeParam: function(key, sourceURL) {
            var rtn = sourceURL.split("?")[0],
                param,
                params_arr = [],
                queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
            if (queryString !== "") {
                params_arr = queryString.split("&");
                for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                    param = params_arr[i].split("=")[0];
                    if (param === key) {
                        params_arr.splice(i, 1);
                    }
                }
                if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
            }
            return rtn;
        },

        renderUrl: function(searchParams) {
            const sectionId = document.querySelector(options.section).dataset.sectionId;
            const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
            return url;
        },

        renderSectionFilter: function(url, searchParams) {
            this.toggleLoading(document.body, true);
            fetch(`${url}`)
                .then((response) => {
                    if (!response.ok) {
                    var error = new Error(response.status);
                    throw error;
                    }
                    return response.text();
                })
                .then(responseText => {
                    const newSection = new DOMParser().parseFromString(responseText, 'text/html').querySelector(options.section);
                    document.querySelector(options.section).replaceWith(newSection);
                    
                    // Only hide overlay if sidebar is not open
                    const collectionSidebar = document.querySelector(options.collectionSidebar);
                    const isSidebarOpen = collectionSidebar && collectionSidebar.classList.contains('bls__opend-popup');
                    
                    if (!isSidebarOpen) {
                        document.querySelector(options.overlay).classList.add('d-none-overlay');
                        document.documentElement.classList.remove('hside_opened');
                    }
                    
                    this.toggleLoading(document.body, false);
                })
                .catch((error) => {
                    throw error;
                })
                .finally(() => {
                    BlsReloadSpr.init();
                    BlsEventCollectionShopify.init();
                    BlsColorSwatchesShopify.init();
                    BlsSubActionProduct.init();
                    setTimeout(function() {
                        BlsLazyloadImg.init();
                    }, 200);
                    
                    // Re-trigger hash replay after filter/sort changes section
                    if (window.location.hash && window.location.hash.includes('p=')) {
                        setTimeout(() => {
                            BlsEventCollectionShopify.replayPagesFromHash();
                        }, 300);
                    }
                });
            this.updateUrl(url, searchParams);
        },

        eventLoadMore: function() {
            document.querySelectorAll(options.collectionsLoadMore).forEach(loadMore => {
                var _this = this;
                if (loadMore.classList.contains('infinit-scrolling')) {
                    var observer = new IntersectionObserver(function (entries) {
                        entries.forEach(entry => {
                            entries.forEach(entry => {
                                if (entry.intersectionRatio === 1){
                                    _this.loadMoreProducts(loadMore);
                                }
                            });
                        });
                    }, {threshold: 1.0});
                    observer.observe(loadMore);
                } else {
                    loadMore.addEventListener("click", event => {
                        event.preventDefault();
                        const target = event.currentTarget;
                        _this.loadMoreProducts(target);
                    }, false);
                }
            });
        },

        loadMoreProducts: function(target) {
            const nextUrl = target.dataset.nextUrl || target.getAttribute('href');
            const sectionId = target.dataset.sectionId;
            const currentPage = parseInt(target.dataset.currentPage || 1);
            
            if (!sectionId) {
                console.error('Section ID missing - falling back to old behavior');
                // Fallback to old behavior if data attributes not available
                const loadMore_url = target.getAttribute('href');
                this.toggleLoading(target, true);
                fetch(`${loadMore_url}`)
                    .then((response) => {
                        if (!response.ok) {
                        var error = new Error(response.status);
                        throw error;
                        }
                        return response.text();
                    })
                    .then(responseText => {
                        const productNodes = parser.parseFromString(responseText, 'text/html');
                        const productNodesHtml = productNodes.querySelectorAll('#bls__product-grid .bls__grid__item');
                        productNodesHtml.forEach(prodNode => document.getElementById("bls__product-grid").appendChild(prodNode));
                        const load_more = productNodes.querySelector('.collections-load-more');
                        document.querySelector(".load-more-amount").innerHTML = productNodes.querySelector('.load-more-amount').textContent;
                        document.querySelector(".load-more-percent").style.width = productNodes.querySelector('.load-more-percent').style.width;
                        if ( load_more ) {
                            target.setAttribute("href", load_more.getAttribute('href'));
                        } else {
                            target.remove();
                        }
                        this.toggleLoading(target, false);
                    })
                    .catch((error) => {
                        throw error;
                    })
                    .finally(() => {
                        BlsColorSwatchesShopify.init();
                        BlsSubActionProduct.init();
                        BlsReloadSpr.init();
                        setTimeout(function() {
                            BlsLazyloadImg.init();
                        }, 200);
                        
                    });
                return;
            }
            
            // New behavior: use sections= parameter for JSON response
            const separator = nextUrl.includes('?') ? '&' : '?';
            const fetchUrl = `${nextUrl}${separator}sections=${encodeURIComponent(sectionId)}`;
            
            this.toggleLoading(target, true);
            fetch(`${fetchUrl}`)
                .then((response) => {
                    if (!response.ok) {
                        var error = new Error(response.status);
                        throw error;
                    }
                    return response.json();
                })
                .then(data => {
                    const sectionHtml = data[sectionId];
                    if (!sectionHtml) {
                        throw new Error('Section HTML not found in response');
                    }
                    
                    const parser = new DOMParser();
                    const productNodes = parser.parseFromString(sectionHtml, 'text/html');
                    const productNodesHtml = productNodes.querySelectorAll('#bls__product-grid .bls__grid__item');
                    productNodesHtml.forEach(prodNode => document.getElementById("bls__product-grid").appendChild(prodNode));
                    
                    // Update progress bar
                    const newLoadMoreAmount = productNodes.querySelector('.load-more-amount');
                    const newLoadMorePercent = productNodes.querySelector('.load-more-percent');
                    if (newLoadMoreAmount && document.querySelector(".load-more-amount")) {
                        document.querySelector(".load-more-amount").innerHTML = newLoadMoreAmount.textContent;
                    }
                    if (newLoadMorePercent && document.querySelector(".load-more-percent")) {
                        document.querySelector(".load-more-percent").style.width = newLoadMorePercent.style.width;
                    }
                    
                    // Update load more button for next page
                    const load_more = productNodes.querySelector('.collections-load-more');
                    if (load_more) {
                        const nextPageUrl = load_more.dataset.nextUrl || load_more.getAttribute('href');
                        const nextPageNumber = load_more.dataset.currentPage;
                        target.setAttribute("href", nextPageUrl);
                        target.dataset.nextUrl = nextPageUrl;
                        target.dataset.currentPage = nextPageNumber;
                    } else {
                        target.remove();
                    }
                    
                    // Update URL hash to reflect current virtual page
                    const newPage = currentPage + 1;
                    const newHash = `#p=${newPage}`;
                    history.replaceState(null, '', newHash);
                    target.dataset.currentPage = newPage;
                    
                    this.toggleLoading(target, false);
                })
                .catch((error) => {
                    console.error('Load more error:', error);
                    this.toggleLoading(target, false);
                    throw error;
                })
                .finally(() => {
                    BlsColorSwatchesShopify.init();
                    BlsSubActionProduct.init();
                    BlsReloadSpr.init();
                    setTimeout(function() {
                        BlsLazyloadImg.init();
                    }, 200);
                });
        },

        toggleLoading: function(event, loading) {
            if (event) {
                if (loading) {
                  event.classList.add('start', 'loading');
                } else {
                  event.classList.add('finish');
                  setTimeout(function() {
                    event.classList.remove('start', 'loading', 'finish');
                  }, 500)
                }
            }
        },

        updateUrl: function(url, searchParams = false) {
            if (searchParams) {
                const urlUpdate = `${window.location.pathname}?${searchParams}`;
                window.history.pushState({url: urlUpdate}, '', urlUpdate);
            } else {
                window.history.pushState({url: url}, '', url);
            }
        },

        replayPagesFromHash: function() {
            // Guard against concurrent replays
            if (isReplayInProgress) return;
            
            // Parse hash to get target page (e.g. #p=3)
            const hash = window.location.hash;
            if (!hash || !hash.includes('p=')) return;
            
            const targetPage = parseInt(hash.replace('#p=', '')) || 1;
            if (targetPage <= 1) return;
            
            const loadMoreButton = document.querySelector(options.collectionsLoadMore);
            if (!loadMoreButton) return;
            
            const sectionId = loadMoreButton.dataset.sectionId;
            if (!sectionId) return;
            
            // Check if products for target page are already loaded (for bfcache scenarios)
            const currentProductCount = document.querySelectorAll('#bls__product-grid .bls__grid__item').length;
            const productsPerPage = parseInt(loadMoreButton.dataset.productsPerPage) || 20; // from Liquid paginate.page_size
            const expectedProducts = targetPage * productsPerPage;
            
            // If products seem to be already there (bfcache), skip reload and just restore scroll
            if (currentProductCount >= expectedProducts * 0.8) {
                setTimeout(() => {
                    this.checkScrollRestore();
                }, 100);
                return;
            }
            
            // Set flag to prevent double replay
            isReplayInProgress = true;
            
            // Build URLs for pages 2..targetPage, preserving current filters/sort
            const currentParams = new URLSearchParams(window.location.search);
            const pagesToLoad = [];
            
            for (let page = 2; page <= targetPage; page++) {
                const params = new URLSearchParams(currentParams);
                params.set('page', page);
                pagesToLoad.push({
                    page: page,
                    url: `${window.location.pathname}?${params.toString()}`
                });
            }
            
            // Load pages sequentially
            const loadNextPage = (index) => {
                if (index >= pagesToLoad.length) {
                    // All pages loaded - update button state
                    this.updateLoadMoreButton(loadMoreButton, targetPage, sectionId);
                    
                    // Trigger lazy load and other inits after all pages loaded
                    BlsColorSwatchesShopify.init();
                    BlsSubActionProduct.init();
                    BlsReloadSpr.init();
                    setTimeout(function() {
                        BlsLazyloadImg.init();
                    }, 200);
                    
                    // Check for scroll restore with delay for Safari compatibility
                    setTimeout(() => {
                        this.checkScrollRestore();
                        // Reset flag after completion
                        isReplayInProgress = false;
                    }, 400);
                    return;
                }
                
                const pageData = pagesToLoad[index];
                const separator = pageData.url.includes('?') ? '&' : '?';
                const fetchUrl = `${pageData.url}${separator}sections=${encodeURIComponent(sectionId)}`;
                
                fetch(fetchUrl)
                    .then(response => response.json())
                    .then(data => {
                        const sectionHtml = data[sectionId];
                        if (!sectionHtml) {
                            loadNextPage(index + 1);
                            return;
                        }
                        
                        const parser = new DOMParser();
                        const productNodes = parser.parseFromString(sectionHtml, 'text/html');
                        const productNodesHtml = productNodes.querySelectorAll('#bls__product-grid .bls__grid__item');
                        productNodesHtml.forEach(prodNode => document.getElementById("bls__product-grid").appendChild(prodNode));
                        
                        // Update progress bar after each page
                        const newLoadMoreAmount = productNodes.querySelector('.load-more-amount');
                        const newLoadMorePercent = productNodes.querySelector('.load-more-percent');
                        if (newLoadMoreAmount && document.querySelector(".load-more-amount")) {
                            document.querySelector(".load-more-amount").innerHTML = newLoadMoreAmount.textContent;
                        }
                        if (newLoadMorePercent && document.querySelector(".load-more-percent")) {
                            document.querySelector(".load-more-percent").style.width = newLoadMorePercent.style.width;
                        }
                        
                        // Load next page
                        loadNextPage(index + 1);
                    })
                    .catch(error => {
                        console.error(`Failed to load page ${pageData.page}:`, error);
                        // Reset flag on error
                        isReplayInProgress = false;
                        loadNextPage(index + 1); // Continue with next page even if one fails
                    });
            };
            
            loadNextPage(0);
        },

        updateLoadMoreButton: function(button, currentPage, sectionId) {
            // Build URL for next page
            const currentParams = new URLSearchParams(window.location.search);
            const nextPage = currentPage + 1;
            const params = new URLSearchParams(currentParams);
            params.set('page', nextPage);
            const nextUrl = `${window.location.pathname}?${params.toString()}`;
            const separator = nextUrl.includes('?') ? '&' : '?';
            const checkUrl = `${nextUrl}${separator}sections=${encodeURIComponent(sectionId)}`;
            
            // Check if next page exists by fetching it
            fetch(checkUrl)
                .then(response => response.json())
                .then(data => {
                    const sectionHtml = data[sectionId];
                    if (!sectionHtml) {
                        button.remove();
                        return;
                    }
                    
                    const parser = new DOMParser();
                    const productNodes = parser.parseFromString(sectionHtml, 'text/html');
                    const hasNextPage = productNodes.querySelector('.collections-load-more');
                    
                    if (hasNextPage) {
                        button.setAttribute('href', nextUrl);
                        button.dataset.nextUrl = nextUrl;
                        button.dataset.currentPage = currentPage;
                    } else {
                        button.remove();
                    }
                })
                .catch(() => {
                    button.remove();
                });
        },

        setupScrollRestore: function() {
            // Listen for clicks on product links to save state
            document.addEventListener('click', (e) => {
                const productLink = e.target.closest('#bls__product-grid a[href*="/products/"]');
                if (!productLink) return;
                
                // Save current state to sessionStorage
                const state = {
                    collectionUrl: window.location.pathname + window.location.search,
                    collectionHash: window.location.hash,
                    scrollY: window.scrollY,
                    productHandle: productLink.getAttribute('href').split('/products/')[1]?.split('?')[0]
                };
                
                sessionStorage.setItem('collectionReturnState', JSON.stringify(state));
            });
        },

        checkScrollRestore: function() {
            const savedState = sessionStorage.getItem('collectionReturnState');
            if (!savedState) return;
            
            try {
                const state = JSON.parse(savedState);
                const currentUrl = window.location.pathname + window.location.search;
                
                // Check if we're on the same collection (pathname match is enough)
                if (!currentUrl.startsWith(state.collectionUrl.split('?')[0])) {
                    sessionStorage.removeItem('collectionReturnState');
                    return;
                }
                
                // Restore scroll position with delay for Safari compatibility
                setTimeout(() => {
                    if (state.scrollY) {
                        window.scrollTo(0, state.scrollY);
                    }
                    
                    // Or scroll to the product card if we have the handle
                    if (state.productHandle) {
                        const productCard = document.querySelector(`#bls__product-grid a[href*="/products/${state.productHandle}"]`);
                        if (productCard) {
                            productCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }
                    }
                    
                    // Clean up
                    sessionStorage.removeItem('collectionReturnState');
                }, 300); // Increased delay for Safari back button
            } catch (e) {
                console.error('Scroll restore error:', e);
                sessionStorage.removeItem('collectionReturnState');
            }
        }
    }
})();
BlsEventCollectionShopify.init();